import { Component, OnInit, OnDestroy, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription, forkJoin } from 'rxjs';
import { DialogOverviewConfirmationComponent } from '../dialog-overview-confirmation/dialog-overview-confirmation.component';
import { SiteSwitcherComponent } from '../site-switcher/site-switcher.component';
import { DialogFacilityComponent } from '../dialog-facility/dialog-facility.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { ProfileService } from '../profile.service';
import { CountryNameService } from '../country.service';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'lib-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss']
})
export class ProfileDetailsComponent implements OnInit , OnDestroy, OnChanges {
  Name;
  mode;
  dataSource;
  currentUserData: any = {};
  @Input() isPlatform: boolean = false;
  @Input() isDisableSetting: boolean = false;
  @Input() isAuditTrail: boolean = true;
  @Input() isPromotionalMessage: boolean = true;
  @Input() isConsentAnalytics: boolean = true;
  @Input() isEnableAppSelection: boolean = true;
  @Input() isServiceListView: boolean = true;
  @Output() profileEvent = new EventEmitter();
  @Input() userprinciplename;
  isGlobalAdmin: boolean = false;
  @Input() institutionname;
  @Input() employeeStatus;
  @Input() clientId;
  @Input() appId;
  selectedIndex: number;
  phoneNumber: any;
  email: any;
  salutation: any;
  lastName: any;
  firstName: any;
  userName: any;
  mobile: any;
  dataToPass: any;
  existingValue;
  existingValueEmail;
  existingValuefname;
  existingValueUname: any;
  existingValueMobile: any;
  existingValuelname;
  existingValuesalutation;
  submitted = false;
  @Input() logOutUrl;
  @Input() clientSecret;
  @Input() productionFlag;
  profileTitles: string = 'Profile Details';
  @Output() dataEvent = new EventEmitter();
  salutationList: string[] = [this.translate.instant('Mr'), this.translate.instant('Mrs'), this.translate.instant('Miss'), this.translate.instant('Ms')];
  @ViewChild('inputModelPhoneNumber') inputModelPhoneNumber;
  @ViewChild('inputModelUsername') inputModelUsername
  @ViewChild('inputModelMobile') inputModelMobile;
  @ViewChild('inputEmailModel') inputEmailModel;
  @ViewChild('lastNameModel') lastNameModel;
  @ViewChild('firstNameModel') firstNameModel;
  @ViewChild('salutationModel') salutationModel;
  defaultuserIcon;
  hideEditVal: boolean = false;
  subscription: Subscription;
  subscription_img: Subscription;
  subscriptionLang: Subscription;
  subscription_res: any;
  subscription_facility: Subscription;
  @Input() applicationID: string = '1';
  roleView: string = '';
  @Input() role: string = '';
  getAccountData: any = [];
  selectIndex: any;
  imageUrl;
  imm;
  institutionList: any = [];
  institutionNameShow: any = '';
  passListData;
  privacyData: string = '';
  termsData: string = '';
  profileName: string = '';
  isNotFound = false;
  // inputModelMobileErrors = false;
  // inputModelErrors = false;
  facilityData: any = {};
  isNotHartmannUser: boolean = true;
  userCountries;
  // @ViewChild('imageUploaderComp') imageUploaderComp: ImageUploaderComponent;
  columnsToDisplay = ['appName', 'appRole'];
  inputModelErrors: boolean = true;
  inputModelMobileErrors: boolean = true;
  selectedCountry: any = "au";
  inputObj: any;
  selCode: any;
  constructor(
    public dialog: MatDialog, 
    public translate: TranslateService, 
    private _location: Location, 
    private apiService: ApiService, 
    private userService: ProfileService, 
    private countryNameService: CountryNameService, 
    private location: Location) { }

  ngOnInit() {
    this.userCountries = JSON.parse(localStorage.getItem('userObject')).userCountries;
    this.isPlatform = this.isPlatform;
    if (localStorage.getItem('Lang') == 'de') {
      this.salutationList = [this.translate.instant('Mr'), this.translate.instant('Mrs')];

    } else {
      this.salutationList = [this.translate.instant('Mr'), this.translate.instant('Mrs'), this.translate.instant('Miss'), this.translate.instant('Ms')];
    }

    this.defaultuserIcon = this.userService.defaultuserIcon;
    this.mode = "View";
    this.getPrivacyData();
    this.subscription = this.userService.profileTabIndex$.subscribe((data) => {
      this.selectIndex = data;
      this.selectedIndex = this.selectIndex;
      this.fromPanel(this.selectedIndex);
      this.dataEvent.emit({ event: "actionfound", value: data });
    });
    this.subscription_img = this.userService.completeUserData$.subscribe(res => {
      this.imageUrl = res.profileImage;
    })
    this.subscriptionLang = this.userService.getUpdatedLanguage$.subscribe(data => {
      if (!!data) {
        localStorage.setItem('Lang', data);
        this.getPrivacyData();
      }
    })
    this.subscription_facility = this.userService.getFacilityLoadData$.subscribe(data => {
      if (data && Object.keys(data).length) {
        this.facilityData = data;
      } else {
        this.facilityData = {};
      }
    })
    this.translate.onLangChange.subscribe(lang => {
      //localStorage.setItem('Lang', lang.lang)
    });
    this.selectedCountry = localStorage.getItem('countryVal').toLowerCase();
  }

  getCountryName(countryCode) {
    return this.countryNameService.getCountryName(countryCode);
  }

  ngOnChanges() {
    this.imm = this.userService.hartmannIcon;
    if (this.userprinciplename && !!localStorage.getItem('userObject'))
      this.subscription_res = JSON.parse(localStorage.getItem('userObject'));
    if (Object.keys(this.subscription_res).length && this.subscription_res) {
      this.currentUserData = this.subscription_res;
      this.existingValue = this.currentUserData.phone;
      this.existingValueEmail = this.currentUserData.email;
      this.existingValuefname = this.currentUserData.firstName;
      this.existingValueUname = this.currentUserData.userName;
      this.existingValueMobile = this.currentUserData.mobile;
      this.existingValuelname = this.currentUserData.lastName;
      this.existingValuesalutation = this.currentUserData.salutation;
      this.dataSource = new MatTableDataSource<any>(this.subscription_res.profileAppList);
      this.passListData = this.subscription_res;
      if (this.passListData.firstName) {
        this.profileName = this.passListData.firstName.charAt(0) + '' + this.passListData.lastName.charAt(0);
      }
      if (this.passListData.profileImage && this.passListData.profileImage != '') {
        this.imageUrl = this.passListData.profileImage;
      }
      if (this.role) {
        this.passListData.healthPlusRoleName = this.role;
      }
      if (this.subscription_res.profileAppList.length == 0) {
        this.isNotFound = true;
      }
      if (this.subscription_res.accountType == 'Hartmann' || this.subscription_res.accountType == 'Developer') {
        this.isNotHartmannUser = false;
        this.userService.userTypeValue.next(this.subscription_res.accountType);
      }
      if (!this.subscription_res.isCountryAdmin && this.subscription_res.healthPlusRoleId == '5de0138f9952be3f746353af') {
        this.isGlobalAdmin = true;
      }
      if (this.currentUserData.associatedAccounts.length && this.applicationID == '1') {
        this.institutionList = this.currentUserData.associatedAccounts;
        this.getAccountData = this.currentUserData.associatedAccounts;
        if (!!localStorage.getItem('defaultID')) {
          let selectedID = this.institutionList.find(res => res.facilityCRMId == localStorage.getItem('defaultID') && res.facilityCountry == localStorage.getItem('countryVal'));
          if (selectedID) {
            this.institutionList = this.institutionList.filter(res => res.facilityCRMId != localStorage.getItem('defaultID') && res.facilityCountry == localStorage.getItem('countryVal'))
            this.institutionList.splice(0, 0, selectedID);
            this.institutionNameShow = selectedID.facilityName;
            localStorage.setItem('defaultID', selectedID.facilityCRMId);
          }
        }
      }
      if (this.applicationID != '1') {
        this.currentUserData.userAppSubscriptionDetails = this.currentUserData.userAppSubscriptionDetails.filter(res => res.appId == this.applicationID);
        if (this.currentUserData.userAppSubscriptionDetails[0] != undefined) {
          if (this.currentUserData.userAppSubscriptionDetails[0].facilitySubscriptionDetails.length) {
            this.getAccountData = this.currentUserData.userAppSubscriptionDetails[0].facilitySubscriptionDetails;
            this.institutionList = this.currentUserData.userAppSubscriptionDetails[0].facilitySubscriptionDetails;
            if (!!localStorage.getItem('defaultID')) {
              let selectedID = this.institutionList.find(res => res.facilityCRMId == localStorage.getItem('defaultID') && res.facilityCountry == localStorage.getItem('countryVal'));
              if (selectedID) {
                this.institutionList = this.institutionList.filter(res => res.facilityCRMId != localStorage.getItem('defaultID') && res.facilityCountry == localStorage.getItem('countryVal'))
                this.institutionList.splice(0, 0, selectedID);
                this.institutionNameShow = selectedID.facilityName;
                localStorage.setItem('defaultID', selectedID.facilityCRMId);
              }
            }

          } else {
            this.roleView = this.currentUserData.userAppSubscriptionDetails[0].appRoleName;
          }
        }
        if (this.role) {
          this.roleView = this.role;
        }
      }

    } else {
      this._location.back();
    }
  }
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.subscription_img) {
      this.subscription_img.unsubscribe();
    }
    if (this.subscriptionLang)
      this.subscriptionLang.unsubscribe();
    // if(this.subscription_res){
    // this.subscription_res.unsubscribe();
    // }
    if (this.subscription_facility) {
      this.subscription_facility.unsubscribe();
    }
  }
  onEdit() {
    this.mode = "Edit";
    this.hideEditVal = true;
    this.submitted = false;
    this.phoneNumber = this.currentUserData.phone;
    this.email = this.currentUserData.email;
    this.lastName = this.currentUserData.lastName;
    this.firstName = this.currentUserData.firstName;
    this.userName = this.currentUserData.userName;
    this.mobile = this.currentUserData.mobile;
    this.salutation = this.currentUserData.salutation;
  }

  onBack() {
    this.location.back();
    this.hideEditVal = false;
  }
  insChange(e) {
    this.institutionNameShow = e;
    var facilityAccount = this.institutionList.find(res => res.facilityName == e && res.facilityCountry == localStorage.getItem('countryVal'));
    this.profileEvent.emit({ event: 'loadInstitution', value: facilityAccount });
    // this.roleValue = facilityAccount.facilityRoleName;
    this.userService.getFacilityDetailsData.next(facilityAccount);
    localStorage.setItem('defaultID', facilityAccount.facilityCRMId);
  }
  redirectFacility(facility) {
    let facilityId = this.institutionList.filter(ele => ele.facilityName == facility && ele.facilityCountry == localStorage.getItem('countryVal'));
    const dialogRef = this.dialog.open(DialogFacilityComponent, {
      width: '900px',
      disableClose: true
    });
    this.dataToPass = {
      facilityCRM: facilityId[0].facilityCRMId,
    };
    dialogRef.componentInstance.facilityData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      if (result.event === 'facilityView') {
        // this.OnUpdateProfile('');
      } else if (result.event === 'profileMoifyError') {
        // this.dataEvent.emit({ event: "profileUpdateError", value: result.message });
      }
    });
    // let facilityId = this.institutionList.filter(ele => ele.facilityName == facility);
    // this.router.navigateByUrl('/administration/institution/facility-details/'+ facilityId[0].facilityCRMId);
  }
  redirectToSwitcher() {
    this.institutionList = this.institutionList.filter(res => res.facilityCountry == localStorage.getItem('countryVal'));
    const dialogRefSwitch = this.dialog.open(SiteSwitcherComponent, {
      width: '550px',
      disableClose: true
    });
    dialogRefSwitch.componentInstance.facilityData = this.institutionList;
    dialogRefSwitch.afterClosed().subscribe(result => {
      if (result.event === 'facilitySelected') {
        this.insChange(result.data)
      }
    });
  }
  getCompleteUserData() {
    this.userService.completeUserData$.subscribe({
      next: data => {
        this.currentUserData = data;
      },
      error: err => { },
      complete: () => { }
    })
  }
  onCancel(event) {
    this.submitted = false;
    this.mode = "View";
    //event.preventDefault();
    this.hideEditVal = false;
  }
  onDataEvent(event) {
    this.dataEvent.emit(event);
  }
  fromPanel(index) {
    if (index == 1) {
      this.profileTitles = 'My Settings';
    }
    if (index == 2) {
      this.profileTitles = 'My Subscription';
    }
    if (index == 3) {
      this.profileTitles = 'Privacy Notice';
    }
    if (index == 4) {
      this.profileTitles = 'Change Password';
    }
    if (index == 5) {
      this.profileTitles = 'Delete My Account';
    }
    if (index == 0) {
      this.profileTitles = 'Profile Details';
    }
  }
  getPrivacyData() {
    const postData = {
      country: localStorage.getItem('countryVal'),
      language: 'en',
      appId: this.appId
    }
    if (!!localStorage.getItem('Lang')) {
      postData.language = localStorage.getItem('Lang');
    }
    forkJoin([
      this.apiService.getPrivacyPolicyByCountry(postData),
      this.apiService.getTermsandConditionByCountry(postData)
    ]).subscribe(([privacyData, termsData]) => {
      if (privacyData) {
        this.privacyData = atob(privacyData.document);
      }
      if (termsData) {
        this.termsData = atob(termsData.document);
      }
    })
  }
  redirectToProfile(index) {
    // if(index == 5 && !this.isNotHartmannUser){
    //   return false;
    // }
    this.userService.profileTabIndex.next(index);
    this.selectedIndex = index;
    this.fromPanel(index);
  }
  logout() {
    // this.userService.logout();
    // this.dataEvent.emit({ event: 'logout' });
    // // window.location.href = this.logOutUrl;

    var postParams = {
      "expires_in": localStorage.getItem('expires_in'),
      "ext_expires_in": localStorage.getItem('ext_expires_in'),
      "access_token": localStorage.getItem('access_token'),
      "refresh_token": localStorage.getItem('refresh_token'),
      "display_name": localStorage.getItem('dispName'),
      "user_principal_name": localStorage.getItem('token'),
      "user_profile_id": localStorage.getItem('user_token'),
      "jobTitle": "",
      "sessionid": localStorage.getItem('sessionId')
    };
    this.apiService.logout(postParams).subscribe(
      () => {
        localStorage.clear();
        // this.dataService.changeExpandValue(true);
        window.location.href = this.logOutUrl;
      }, (err) => {
        localStorage.clear();
        // this.dataService.changeExpandValue(true);
        window.location.href = this.logOutUrl;
      });
  }
  updateProfileDetails() {
    const dialogRef = this.dialog.open(DialogOverviewConfirmationComponent, {
      width: '500px',
      disableClose: true
    });
    this.dataToPass = {
      profileUpdate: true,
    };
    dialogRef.componentInstance.confirmData = this.dataToPass;
    dialogRef.afterClosed().subscribe(result => {
      this.phoneNumber = this.currentUserData.phone;
      if (result.event === 'profileMoify') {
        this.OnUpdateProfile();
      } else if (result.event === 'profileMoifyError') {
        this.dataEvent.emit({ event: "profileUpdateError", value: result.message });
      }
    });
  }
  onSave(event) {
    event.preventDefault();
    this.submitted = true;
    var attributeInvalid = false;
    if ((this.mobile != '' && this.inputModelMobileErrors == false) || this.inputModelErrors == false || this.firstNameModel.invalid || this.salutationModel.invalid || (this.phoneNumber != '' && this.inputModelPhoneNumber.invalid) || this.lastNameModel.invalid || this.inputEmailModel.invalid || this.inputModelUsername.invalid) {
      attributeInvalid = true;
      return false;
    }
    if (attributeInvalid) {
      return false;
    }
    if (this.existingValue != this.phoneNumber || this.existingValueUname != this.userName || this.existingValueMobile != this.mobile || this.existingValueEmail != this.email || this.existingValuesalutation != this.salutation || this.existingValuefname != this.firstName || this.existingValuelname != this.lastName) {
      this.updateProfileDetails();
    } else {
      this.OnUpdateProfile();
    }
  }
  OnUpdateProfile() {
    const fileFormDetails = {
      userId: this.userprinciplename,
      phone: this.phoneNumber == '+' + this.selCode ? '' : this.phoneNumber,
      salutation: this.salutation,
      email: this.email,
      lastName: this.lastName,
      firstName: this.firstName,
      userName: this.userName,
      mobile: this.mobile == '+' + this.selCode ? '' : this.mobile,
      contactCRMId: this.currentUserData.contactCRMId
    }
    var Response: Array<any> = [];
    Response[0] = this.apiService.uploadUserProfileDetails(fileFormDetails);
  
    forkJoin(Response).subscribe({
      next: ([resAllData, resImageDetail]) => {
        if (resImageDetail) {
          this.currentUserData.profileImage = resImageDetail;
          this.userService.changeCompleteUserData(this.currentUserData);
        }
        this.currentUserData.phone = this.phoneNumber;
        this.currentUserData.email = this.email;
        this.hideEditVal = false;
        this.currentUserData.lastName = this.lastName;
        this.currentUserData.firstName = this.firstName;
        this.currentUserData.userName = this.userName;
        this.currentUserData.mobile = this.mobile;
        this.currentUserData.salutation = this.salutation;
        this.existingValue = this.phoneNumber;
        this.existingValueEmail = this.email;
        this.existingValuefname = this.firstName;
        this.existingValueUname = this.userName;
        this.existingValueMobile = this.mobile;
        this.existingValuelname = this.lastName;
        this.existingValuesalutation = this.salutation;
        this.mode = "View";
        this.submitted = false;
        this.profileName = this.currentUserData.firstName.charAt(0) + '' + this.currentUserData.lastName.charAt(0);
        this.dataEvent.emit({ event: "profileUpdateSuccess", data: this.currentUserData });
        localStorage.setItem('userObject', JSON.stringify(resAllData));
      },
      error: err => {
        if (err.error.message != '') {
          this.dataEvent.emit({ event: 'error', message: err.error.error_code })
        }
      },
      complete: () => { }
    })
  }

  validateNumber(event) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46, 187];
    if (!((keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
    }
  }

  hasError(obj) {
    var removedCode = this.phoneNumber.replace(('+' + this.selCode), '')
    if (removedCode != '') {
      this.inputModelErrors = obj;
    } else {
      this.inputModelErrors = true;
    }

  }

  getNumber(obj) {
    this.phoneNumber = obj;
  }

  onCountryChange(obj) {
    this.phoneNumber = this.phoneNumber != '' ? this.phoneNumber.replace(('+' + this.selCode), "+" + obj.dialCode) : ('+' + obj.dialCode);
    this.mobile = this.mobile != '' ? this.mobile.replace(('+' + this.selCode), "+" + obj.dialCode) : ('+' + obj.dialCode);
    this.selCode = obj.dialCode;
  }

  telInputObject(obj) {
    this.inputObj = obj;
    this.inputObj.setCountry(this.selectedCountry)
    this.selCode = obj.s.dialCode;
    this.phoneNumber = (this.phoneNumber && this.phoneNumber != '') ? this.phoneNumber.replace(('+' + this.selCode), "+" + obj.s.dialCode) : ('+' + obj.s.dialCode);
    this.mobile = (this.mobile && this.mobile != '') ? this.mobile.replace(('+' + this.selCode), "+" + obj.s.dialCode) : ('+' + obj.s.dialCode);
  }
  hasErrorMobile(obj) {
    var removedCode = this.mobile.replace(('+' + this.selCode), '')
    if (removedCode != '') {
      this.inputModelMobileErrors = obj;
    } else {
      this.inputModelMobileErrors = true;
    }
  }

  getNumberMobile(obj) {
    this.mobile = obj;
  }
}